import React from "react"
import ZigZagContentBlokProps from "./ZigZagContent.interface"
import ZigZagGenerator from "./ZigZagContentGenerator.component"

const ZigZagContentHeavy: React.FC<ZigZagContentBlokProps> = props => (
  <ZigZagGenerator {...props} />
)

export default ZigZagContentHeavy
